import { createFileRoute } from "@tanstack/react-router";
import Contact from "@/pages/Contact";

export const Route = createFileRoute("/contact")({
  head: () => ({
    meta: [
      { title: "Contact – De Hussel App" },
      { name: "description", content: "Neem contact op met De Hussel App. Vragen over onze tennis hussel- en tossavond app? We helpen je graag." },
      { property: "og:title", content: "Contact – De Hussel App" },
      { property: "og:description", content: "Neem contact op met De Hussel App. Vragen over onze tennis hussel- en tossavond app? We helpen je graag." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://dehusselapp.nl/contact" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://dehusselapp.nl/contact" }],
  }),
  component: Contact,
});
